// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"a90b7a78","386":"7a817893","453":"7a4423e2","555":"c4f89365","615":"8477b187","673":"ed7c743b","683":"e7d1f3cf","773":"92549c00","780":"56d58dcc","818":"ae31b3e5"}[chunkId] + ".chunk.js";
};